import { Component, HostListener } from "@angular/core";

@Component({
  selector: "pass-visibilty-icon",
  host: {
    "class": "pass-visibility-icon"
  },
  template: `
    <div [ngClass]="{'icon-eye-blind': aType === 'password', 'icon-eye-vision': aType != 'password'}" ></div>
  `
})
export class PassVisibilityIconComponent {
  public aType = "password"; // "text";

  get type() {
    return this.aType;
  }

  @HostListener("click") onClick() {
    this.aType = this.aType === "password" ? "text" : "password";
  }
}
